import {saveData, customFind, getData, clearData} from "../db/db_helper"

const isToday = (dateStr) => {
    if (!dateStr) return false
    const d = new Date(dateStr)
    const now = new Date()
    return d.getFullYear() === now.getFullYear() &&
           d.getMonth() === now.getMonth() &&
           d.getDate() === now.getDate()
}

export const findByUserCodeNoAccounted = async (user) => {
    const online = await customFind("time_tracking", codeAndNoAccountedFilter(user.numberCode))
    const offline = await customFind("sync_time_tracking", codeAndNoAccountedFilter(user.numberCode))
    const entry = online || offline || null
    return entry && isToday(entry.startTime) ? entry : null
}

const codeAndNoAccountedFilter = (code) => (i) => {
    return i?.user?.numberCode === code && i?.endTime === null
} 

const getIndex = (id, array)=>{
    return array.findIndex(o => o.offlineId === id);
}
export const saveOnlineTimeTracking = async(obj)=>{
    saveData("time_tracking", obj)
}
export const saveTimeTracking = async(obj)=>{
    saveData("sync_time_tracking", obj)
}
export const getOfflineTimeTracking = async() =>{
    return await getData("sync_time_tracking") || []
}
export const getOnlineTimeTracking = async() =>{
    return await getData("time_tracking") || []
}
export const clearOfflineTimetracking = async() =>{
    clearData("sync_time_tracking")
}

export const createOrUpdateTimeTracking = async(obj) =>{
    const target = obj
    const online = await getOnlineTimeTracking()
    const offline = await getOfflineTimeTracking()

    let index = -1

    // Removwe from Serverdata and update in syncData
    index = await getIndex(obj.offlineId, online)
    if(index !== -1){
        online.splice(index,1)
        await saveData("time_tracking", online)
        offline.push(target)
        await saveData("sync_time_tracking", offline)
        return
    }

    // Change in SyncData
    index = await getIndex(obj.offlineId, offline)
    if(index !== -1){
        offline[index] = target
        await saveData("sync_time_tracking", offline)
        return
    }

    // Create new Entry
    offline.push(target)
    await saveData("sync_time_tracking", offline)
    return
}